import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Layout, PageHeader, Card, Menu, Col, Row } from "antd";
import { SettingOutlined, HddOutlined, ApartmentOutlined, TeamOutlined } from "@ant-design/icons";

import {
  projectsPath,
  projectSubgraphsPath,
  projectEndpointPath,
  projectSettingsPath,
  projectCollaboratorsPath,
} from "../../helpers/paths";
import { getSelected } from "../../helpers/selected";
import { Endpoints } from "../../components/tabs/Endpoints";
import { SubgraphList } from "../../components/tabs/SubgraphList";
import { Collaborators } from "../../components/tabs/Collaborators";
import { PROJECT_QUERY } from "../../helpers/graphql/project";
import { ProjectDetails } from "../../components/tabs/ProjectDetails";
import { DeleteProject } from "../../components/modal/DeleteProject";

export function Project() {
  const navigate = useNavigate();

  const { id } = useParams();
  const { loading, data } = useQuery(PROJECT_QUERY, {
    variables: { projectId: id },
  });
  const project = data?.project;

  const location = useLocation();

  const items = [
    {
      label: <Link to={projectSubgraphsPath(id || "")}>Subgraphs</Link>,
      key: "subgraphs",
      icon: <ApartmentOutlined />,
    },
    {
      label: <Link to={projectEndpointPath(id || "", "cronos", "mainnet", "shared")}>RPC</Link>,
      key: "endpoints",
      icon: <HddOutlined />,
    },
    {
      label: <Link to={projectCollaboratorsPath(id || "")}>Collaborators</Link>,
      key: "collaborators",
      icon: <TeamOutlined />,
    },
    {
      label: <Link to={projectSettingsPath(id || "")}>Settings</Link>,
      key: "settings",
      icon: <SettingOutlined />,
    },
  ];

  const selectedKey = getSelected(
    [
      { key: "subgraphs", matcher: /^\/projects\/.*\/subgraphs.*/ },
      { key: "endpoints", matcher: /^\/projects\/.*\/endpoints/ },
      { key: "settings", matcher: /^\/projects\/.*\/settings/ },
      { key: "collaborators", matcher: /^\/projects\/.*\/collaborators/ },
    ],
    location.pathname,
    "",
  );

  const subgraphCluster = getSelected(
    [
      { key: 'v2', matcher: /^\/projects\/.*\/subgraphs-v2/},
      { key: 'v1', matcher: /^\/projects\/.*\/subgraphs/}
    ],
    location.pathname,
    'v1'
  )

  return (
    <Layout className="content">
      <Layout.Header className="content-header">
        <Row>
          <Col span={12}>
            <PageHeader
              title={project ? project.name : "Project Details"}
              className="page-title"
              onBack={() => navigate(projectsPath())}
            />
          </Col>
          {/* Delete project */}
          <Col span={12} style={{ textAlign: "end" }}>
            {project ? <DeleteProject projectId={project.id} /> : null}
          </Col>
        </Row>
      </Layout.Header>
      <Layout.Content className="content-body">
        <Menu
          items={items}
          mode="horizontal"
          defaultSelectedKeys={selectedKey !== "" ? [selectedKey] : []}
        />

        <Card loading={loading} bordered={false}>
          {project ? (
            <>
              {selectedKey === "subgraphs" ? <SubgraphList project={project} cluster={subgraphCluster} /> : <></>}
              {selectedKey === "endpoints" ? <Endpoints project={project} /> : <></>}
              {selectedKey === "collaborators" ? <Collaborators project={project} /> : <></>}
              {selectedKey === "settings" ? <ProjectDetails project={project} /> : <></>}
            </>
          ) : (
            <>Error</>
          )}
        </Card>
      </Layout.Content>
    </Layout>
  );
}
